import $ from 'jquery';

export default function ($compile, lodash, DATATABLES) {
    return {
        createExtendableTableOptionsForCourseReport: ($scope) => {
            return lodash.merge({}, DATATABLES, {
                info: false,
                ordering: false,
                paging: false,
                responsive: {
                    auto: true,
                    details: {
                        type: 'inline',
                        target: '1',
                        renderer: (api, rowIdx) => {
                            const mapper = function (cell) {
                                const header = $(api.column(cell.column).header());
                                const cn = $(api.cell(cell).nodes()).attr('class') || '';
                                return `
                                    <div class="row ${header.attr('class')}">
                                        <div class="cell-label">${header.text()}</div>
                                        <div class="cell-value ${cn}">${api.cell(cell).data()}</div>
                                     </div>
                                `;
                            };
                            let data = api.cells(rowIdx, ':hidden').eq(0).map(mapper).toArray().join('');
                            const courseId = $(data).find('.course-id').html(); // we need to extract courseId and pass it to the ng-click function
                            if (courseId) {
                                data = data.replace('course.id', courseId);
                            }
                            return data ? $compile($('<div />').append(data))($scope) : false; // we need to pass scope in order for datatables to support ng-... actions
                        }
                    }
                }
            });
        }
    };
}




// WEBPACK FOOTER //
// ./src/app/factories/dtTable/index.js